import { ModalStore } from '../../state/ModalStore'
import ModalHeader from './ModalHeader'
import ModalContent from './ModalContent'
import ModalContentWrapper from './ModalContentWrapper'
import ModalFooter from './ModalFooter'
import ModalMainWrapper from './ModalMainWrapper'

export default function WentWrong({ title = 'Something went wrong', msg }) {
    const skim = ModalStore((state) => state.skim)

    return (
        <ModalMainWrapper>
            <ModalContentWrapper size="md">
                <ModalHeader title={title} />
                <ModalContent>{msg}</ModalContent>
                <ModalFooter type="alert" confirmText="OK" onConfirm={skim} />
            </ModalContentWrapper>
        </ModalMainWrapper>
    )
}
